import { get } from 'lodash';
import { APP_SETTINGS_MODAL_OPENED } from '../actions/app-settings-modal-opened';
import appSettingsModalClosed from '../actions/app-settings-modal-closed';

export default function appSettingsModalMiddleware() {
  let appSettingsWindow;

  return ({ dispatch }) => next => action => {
    if (action.type === APP_SETTINGS_MODAL_OPENED) {
      appSettingsWindow = getAppSettingsWindow();
      if (appSettingsWindow) {
        appSettingsWindow.addEventListener('unload', () => {
          appSettingsWindow = undefined;
          dispatch(appSettingsModalClosed());
        });
      }
    }
    return next(action);
  };
}

function getAppSettingsWindow() {
  const frames = get(window, 'parent.parent.frames', []);
  for (let i = 0; i < frames.length; i++) {
    try {
      const frame = frames[i];
      if (frame.location.pathname === '/app-settings') {
        return frame;
      }
    } catch (ex) {
      // CORS exception;
    }
  }
  return undefined;
}
